import { render } from "./EntregaUniformes.vue?vue&type=template&id=6fadb83a&scoped=true"
import script from "./EntregaUniformes.vue?vue&type=script&lang=js"
export * from "./EntregaUniformes.vue?vue&type=script&lang=js"

import "./EntregaUniformes.vue?vue&type=style&index=0&id=6fadb83a&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fadb83a"]])

export default __exports__